require('./hireCardOpenDebitError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const WizardError = require('components/commons/wizardError/wizardError');
const { analyticsId, catalogue } = require('../analytics/hireCardOpenDebitAnalytics');

class hireCardOpenDebitError extends React.Component {
    buildTexts() {
        const { isErrorAvailableAccounts, immHireCardOpenDebit, hireRestrictionFlag } = this.props;
        let errorMsg = immHireCardOpenDebit.get('errorMsg');

        let titleKey;
        let textElement;

        if (isErrorAvailableAccounts) {
            titleKey = 'hireCardOpenDebit-errorTitleGeneric';
            textElement = <FormattedText value="hireCardOpenDebit-notAvailableAccounts" />;
        } else if (!!errorMsg) {
            titleKey = 'hireCardOpenDebit-errorTitleNotAllowed';
            textElement = <FormattedText value={`hireDebitErrors-${errorMsg}`} />;
        } else {
            titleKey = 'hireCardOpenDebit-errorTitleGeneric';
            textElement = <FormattedText value="hireCardOpenDebit-errorTextGeneric" />;
        }
        if (isErrorAvailableAccounts && __CONTACT_CENTER__) {
            titleKey = 'hireCardOpenDebit-errorTitleNotAvailableAccounts';
            textElement = <FormattedText value="hireCards-errorTextNotAvailableAccounts" />;
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />;
        }
        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { processDetail, hireRestrictionFlag } = this.props;
        const { textElement, titleKey, isErrorAvailableAccounts } = this.buildTexts();
        const goBackButton =hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }:
            isErrorAvailableAccounts && __CONTACT_CENTER__
            ?
                {
                    label: (
                        <FormattedText
                            format="uppercase"
                            value="hireCards-backButtonLabel"
                        />
                    ),
                    url: '/myprofile/cards'
                }
            :
                {
                    label: (
                        <FormattedText
                            format="uppercase"
                            value="hireCardOpenDebit-errorBackButtonText"
                        />
                    ),
                    url: '/myprofile/global'
                }
        const cancleButton ={
                    label: (
                        <FormattedText
                            value="hireCard-errorRestrictionCancleButtonText"
                        />
                    ),
                    url: '/myprofile/cards'
                    };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.OPEN_DEBIT_CARD_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-card-open-debit-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

hireCardOpenDebitError.propTypes = {
    isErrorAvailableAccounts: PropTypes.bool,
    immHireCardOpenDebit: PropTypes.object.isRequired,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

hireCardOpenDebitError.defaultProps =
{
    hireRestrictionFlag : false
}
module.exports = hireCardOpenDebitError;
